"use strict";

/**
 * @classdesc
 * Einstellungen-Modul
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCSettings
 * @author Anton Popov <a.popov@brain-scc.de>
 * @author Chrisian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCSettings} options.module Modul-Instanz
 */
gc.gis.module.GCSettings.Panel = function( options )
{
	gc.gis.assert.isSet( options );
	gc.gis.assert.isInstance( options.module, gc.gis.module.GCSettings );
	this.module = options.module;

	/**
	 * Formular
	 * @type {gc.gis.util.GCForm|null}
	 * @private
	 */
	this._form = null;

	var options_widget = {
		className: 'gc-settings'
	};
	gc.gis.widget.GCPanel.call( this, options_widget );

	this.element = this._render();
	this._initContent();
};
gc.gis.module.GCSettings.Panel.prototype = Object.create( gc.gis.widget.GCPanel.prototype );

/**
 *
 */
gc.gis.module.GCSettings.Panel.prototype._initContent = function()
{
	var self = this;
	var form_config = {
		className: 'gc-form-settings',
		controls: [
			{
				label: 'Anzeige',
				type: 'advanced',
				active: true,
				controls: [
					{
						label: 'Vollbildansicht aktivieren',
						name: 'fullscreen',
						type: 'checkbox',
						active: gc.gis.iface.ui.isFullscreenEnabled(),
						initFunc: function( control ) {
							gc.gis.iface.ui.on( gc.gis.ui.GCUserInterfaceEvent.FULLSCREEN_CHANGED, this, function( evt ) {
								control._element.prop('checked', ( evt.active === true ) );
							} );
						},
						click: function( evt ) {
							gc.gis.iface.ui.toggleFullscreen();
						}
					},
					{
						label: 'Kartensteuerelemente anzeigen',
						name: 'show_map_controls',
						type: 'checkbox',
						active: gc.gis.iface.ui.isMapControlsVisible(),
						initFunc: function( control ) {
							gc.gis.iface.ui.on( gc.gis.ui.GCUserInterfaceEvent.TOGGLE_MAP_CONTROLS, this, function( evt ) {
								control._element.prop('checked', ( evt.active === true ) );
							} );
						},
						click: function( evt ) {
							gc.gis.iface.ui.toggleMapControls();
						}
					},
					{
						label: 'Fußzeile anzeigen',
						name: 'show_footer',
						type: 'checkbox',
						active: gc.gis.iface.ui.isFooterVisible(),
						initFunc: function( control ) {
							gc.gis.iface.ui.on( gc.gis.ui.GCUserInterfaceEvent.TOGGLE_FOOTER, this, function( evt ) {
								control._element.prop('checked', ( evt.active === true ) );
							} );
						},
						click: function( evt ) {
							gc.gis.iface.ui.toggleFooter();
						}
					},
					{
						label: 'ausgeblendete Meldungen wieder anzeigen',
						name: 'reset_message_excludes',
						type: 'button',
						initFunc: function(control) {
							gc.gis.iface.ui.on(gc.gis.ui.GCUserInterfaceEvent.EXCLUDE_MESSAGES_CHANGED, this, function(evt) {
								if (self._form)
								{
									evt.numNew > 0 ? self._form.enable('reset_message_excludes')
										: self._form.disable('reset_message_excludes');
								}
							});
						},
						click: function(evt) {
							gc.gis.iface.ui.resetMessageExludes();
						}
					}
				]
			}
		]
	};

	this._form = gc.gis.util.GCFormRenderer.renderForm(form_config);
	this.element_content.append(this._form.getElement());

	// Status des Button setzen, leider kommt man in der initFunc nicht so komfortabel ran
	gc.gis.iface.ui.numMessageExludes() > 0 ?
		this._form.enable('reset_message_excludes') : this._form.disable('reset_message_excludes');
};
